import type { MessageImagePayload } from 'models';
import { useMemo } from 'react';

type ImageLayoutKind = 'double' | 'overflow' | 'quad' | 'single' | 'triple';

export const useImageLayout = (images: MessageImagePayload[]): ImageLayoutKind | null =>
  useMemo(() => {
    const count = images.length;

    if (count === 0) {
      return null;
    }

    if (count === 1) {
      return 'single';
    }

    if (count === 2) {
      return 'double';
    }

    if (count === 3) {
      return 'triple';
    }

    if (count === 4) {
      return 'quad';
    }

    return 'overflow';
  }, [images]);
